import { useState, useEffect } from "react";

function useIsMobile(breakpoint = 768): boolean {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth <= breakpoint : false
  );

  useEffect(() => {
    if (typeof window === "undefined") return;

    const mql = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const handleChange = (e: MediaQueryListEvent) => {
      setIsMobile(e.matches);
    };

    mql.addEventListener("change", handleChange);
    setIsMobile(mql.matches);

    return () => {
      mql.removeEventListener("change", handleChange);
    };
  }, [breakpoint]);

  return isMobile;
}

export default useIsMobile;
